export default {
  data () {
    return {
      columns: [
        {
          label: 'Имя',
          field: 'name',
          name: 'name',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Статус',
          field: 'status',
          name: 'status',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          label: 'Дата обновления',
          field: 'updated_at',
          name: 'updated_at',
          sortable: true,
          filter: '',
          align: 'left'
        },
        {
          name: 'del',
          field: 'id'
        }
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/VersionsList/mixins/columns.js